import React, { useRef, useState } from 'react';
import { Box } from '@material-ui/core';
import edit from 'src/assets/images/Edit.svg';
import ItemRPTemplateDesktop from './itemRPTemplateDesktop';
const RowContainerRPDesktop = ({
    classes,
    selectedChildEditItem,
    item,
    index,
    editItem,
    editChildItem,
    selectedChildIndex,
    selectedChildItem,
    editedItemList,
    editedChildItemList,
    addSerialNumber,
    lotSerialValueEntered,
    onAccountOwnedSeleted,
    deleteItem,
    displayPrice,
    showBundlefromTableList,
    isBundleExpanded,
    setIsBundleExpanded,
    isFromReportScreen,
    checkboxReportPaymentClickHandler,
    reportPaymentGridData,
    setReportPaymentGridData,
    selectedCheckBox,
    checkBoxSelectedIndex,
    reportUsageFormObj,
    checkNewAddedProduct,
    deletePO,
    onImagePreview,
    myCaseResourceType,
    vendorCaseErrorRedirection,
    onIsSerialUnknown,
}) => {
    const winWidth = window.innerWidth;
    const [showChildItem, collapseChildItem] = useState(true);
       const childRef = useRef(null);
    return (
        <>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <ItemRPTemplateDesktop
                    key={item.productCFN}
                    classes={classes}
                    item={item}
                    index={index}
                    edit={edit}
                    editItem={editItem}
                    editedItemList={editedItemList}
                    addSerialNumber={addSerialNumber}
                    lotSerialValueEntered={lotSerialValueEntered}
                    onAccountOwnedSeleted={onAccountOwnedSeleted}
                    deleteItem={deleteItem}
                    displayPrice={displayPrice}
                    showBundlefromTableList={showBundlefromTableList}
                    editChildItem={editChildItem}
                    selectedChildItem={selectedChildItem}
                    selectedChildEditItem={selectedChildEditItem}
                    selectedChildIndex={selectedChildIndex}
                    editedChildItemList={editedChildItemList}
                    bundleHeader={item.isBundleFromAddItem}
                    isBundleExpanded={isBundleExpanded}
                    setIsBundleExpanded={setIsBundleExpanded}
                    isFromReportScreen={isFromReportScreen}
                    checkboxReportPaymentClickHandler={
                        checkboxReportPaymentClickHandler
                    }
                    reportPaymentGridData={reportPaymentGridData}
                    setReportPaymentGridData={setReportPaymentGridData}
                    selectedCheckBox={selectedCheckBox}
                    checkBoxSelectedIndex={checkBoxSelectedIndex}
                    reportUsageFormObj={reportUsageFormObj}
                    checkNewAddedProduct={checkNewAddedProduct}
                    deletePO={deletePO}
                    isCheckBoxSelected={item.isSelected}
                    onImagePreview={onImagePreview}
                    myCaseResourceType={myCaseResourceType}
                    collapseChildItem={collapseChildItem}
                    showChildItem={showChildItem}
                    vendorCaseErrorRedirection={vendorCaseErrorRedirection}
                    childRef={childRef}
                    onIsSerialUnknown={onIsSerialUnknown}
                />
                {showChildItem &&
                    item.bundleItem &&
                    item.bundleItem.length > 0 &&
                    item.bundleItem.map((subitem, i) => (
                        <Box
                            className={classes.paper}
                            my={1}
                            bgcolor={'#ffffff'}
                            boxShadow={2}
                            borderRadius={6}
                            style={{
                                display: 'block',
                                backgroundColor: '#FBFAFF',
                                boxShadow: '0px 0px 2px #00000029',
                                width: '95%',
                                margin: '15px auto',
                            }}
                            key={subitem + ' ' + i}
                        >
                            <ItemRPTemplateDesktop
                                winWidth={winWidth}
                                key={subitem.productCFN}
                                classes={classes}
                                item={subitem}
                                parentItem={item}
                                parentIndex={index}
                                index={i}
                                edit={edit}
                                editItem={(editProduct, childIndex) =>
                                    editItem(editProduct, childIndex, index)
                                }
                                editedItemList={(event, editItem, itemIndex) =>
                                    editedItemList(
                                        event,
                                        editItem,
                                        itemIndex,
                                        index
                                    )
                                }
                                addSerialNumber={(product, itemIndex) =>
                                    addSerialNumber(product, itemIndex, index)
                                }
                                lotSerialValueEntered={(
                                    event,
                                    item,
                                    itemIndex,
                                    lotItem,
                                    lotItemIndex
                                ) =>
                                    lotSerialValueEntered(
                                        event,
                                        item,
                                        itemIndex,
                                        lotItem,
                                        lotItemIndex,
                                        undefined,
                                        index
                                    )
                                }
                                onAccountOwnedSeleted={onAccountOwnedSeleted}
                                deleteItem={(
                                    itemIndex,
                                    lotindex,
                                    bundleIndex,
                                    bundleValue
                                ) => {
                                    deleteItem(
                                        itemIndex,
                                        lotindex,
                                        index,
                                        bundleValue
                                    );
                                }}
                                displayPrice={displayPrice}
                                isFromReportScreen={isFromReportScreen}
                                showBundlefromTableList={
                                    showBundlefromTableList
                                }
                                checkNewAddedProduct={checkNewAddedProduct}
                                editChildItem={editChildItem}
                                selectedChildItem={selectedChildItem}
                                selectedChildEditItem={selectedChildEditItem}
                                selectedChildIndex={selectedChildIndex}
                                editedChildItemList={editedChildItemList}
                                bundleHeader={false}
                                //isFromReportScreen={isFromReportScreen}
                                isChildItem
                                checkboxReportPaymentClickHandler={
                                    checkboxReportPaymentClickHandler
                                }
                                reportPaymentGridData={reportPaymentGridData}
                                setReportPaymentGridData={
                                    setReportPaymentGridData
                                }
                                selectedCheckBox={selectedCheckBox}
                                checkBoxSelectedIndex={checkBoxSelectedIndex}
                                reportUsageFormObj={reportUsageFormObj}
                                //checkNewAddedProduct={checkNewAddedProduct}
                                isCheckBoxSelected={item.isSelected}
                                onImagePreview={onImagePreview}
                                myCaseResourceType={myCaseResourceType}
                            />
                        </Box>
                    ))}
            </Box>
        </>
    );
};
export default RowContainerRPDesktop;
